import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Button, ButtonToolbar, Modal, Col, Row, Card, CardBody, Container} from 'reactstrap';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import * as TextManager from "../modules/languages/TextManager";
import NumberFormat from 'react-number-format';
import Alert from "./Alert";
import validateEmail from '../modules/validate'




class ModalESim extends PureComponent {
    static propTypes = {
        title: PropTypes.string,
        message: PropTypes.string,
        color: PropTypes.string.isRequired,
        colored: PropTypes.bool,
        header: PropTypes.bool
    };

    constructor(props) {
        super(props);
        this.state = {
            //modal: true,
            warning: '',
            errorText: '',
            email: props.data && props.data.email ? props.data.email : '',
            phone: props.data && props.data.phone_number ? props.data.phone_number : ''
        };
    }

    componentDidMount() {
        //this.props.dispatch(fetchTasksDataIfNeeded(true));
    }

    save = () => {

        if (this.state.email === '' && this.state.phone === '') {
            this.setState({warning: 'שדה דוא\'ל או מספר טלפון - חובה'});
            return;
        }

        if(this.state.phone.length > 0 && this.state.phone.length !== 10) {
            this.setState({warning: "מספר מנוי חייב להיות באורך של 10 מספרים"});
            return;
        }

        if(this.state.email.length > 0 && !validateEmail(this.state.email)) {
            this.setState({warning: "דוא'ל לא תקף"});
            return;
        }

        this.setState({warning: ''});

        this.props.saveEsimData(this.state.phone, this.state.email);

        this.props.toggle();

    };

    toggle = () => {
        this.props.toggle();
    };

    render() {

        let Icon;
        switch (this.props.color) {
            case 'primary':
                Icon = <span className='lnr lnr-pushpin modal__title-icon'/>;
                break;
            case 'success':
                Icon = <span className='lnr lnr-thumbs-up modal__title-icon'/>;
                break;
            case 'warning':
                Icon = <span className='lnr lnr-flag modal__title-icon'/>;
                break;
            case 'danger':
                Icon = <span className='lnr lnr-cross-circle modal__title-icon'/>;
                break;
            default:
                break;
        }

        return (
            <div onClick={this.toggle}>
                {this.props.children}
                <Modal isOpen={this.props.isESimShow} toggle={this.toggle} style={{maxWidth: '800px', width: '800px'}}
                       className={`modal-dialog--${this.props.color} ${this.props.colored ? 'modal-dialog--colored' : ''} ${this.props.header ? 'modal-dialog--header' : ''}`}>
                    <div className='modal__header'>
                        <span className='lnr lnr-cross modal__close-btn' onClick={this.toggle}/>
                        {this.props.header ? '' : Icon}
                        <h4 className='bold-text  modal__title'>{this.props.title}</h4>
                    </div>
                    <div className='modal__body'>
                        <Container className='dashboard'>
                            {this.state.warning !== '' &&
                            <Row>
                                <Alert color='warning' className='alert--bordered' icon>
                                    <p><span
                                        className='bold-text'>{TextManager.getCurrentTextResource().Text.validation}</span> {this.state.warning}
                                    </p>
                                </Alert>
                            </Row>}
                            <Row style={{flexDirection: "row-reverse"}}>
                                <Alert color='primary' className='alert--bordered'>
                                    <h4 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>{'אליך לטלפון'} </span><span style={{fontWeight: '800'}}>אחר</span>  <span>{'או לכתובת מייל'} </span> <span>{'\xa0'}QR{'\xa0'}</span><span>{'\xa0'}{'אנו נשלח קוד'}{'\xa0'}</span><span>eSim</span><span>-על מנת להפעיל את ה</span>
                                    </h4>
                                    <h5 className='bold-text  modal__title' style={{textAlign: 'center'}}>
                                        <span>:אנא הזן<span style={{fontWeight: '800'}}>{'\xa0'}לפחות אחד{'\xa0'}</span>מ2 הפרטים הבאים</span>
                                    </h5>
                                </Alert>
                            </Row>
                            <Row>
                                <Col md={12} lg={12}>
                                    <form className="form">
                                        <div className="form__form-group">
                                            <div className="form__form-group">
                                                <div className="form__form-group-field" style={{flexDirection: "column"}}>
                                                    <Row style={{flexDirection: "row-reverse"}}>
                                                        <Col md={3} xs={12}>
                                                            <label className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Text.phoneNumber} אחר
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <NumberFormat name="customerName"
                                                                       style={{backgroundColor: '#F0F8FF'}}
                                                                       value={this.state.phone}
                                                                       type="text"
                                                                       dir={"auto"}
                                                                       onChange={(event) =>
                                                                           this.setState({phone: event.target.value})}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>

                                                    <div className="form__form-group" style={{paddingTop: '0.5rem'}}></div>

                                                    <Row style={{flexDirection: "row-reverse"}}>
                                                        <Col md={3} xs={12}>
                                                            <label className="form__form-group-label">
                                                                {TextManager.getCurrentTextResource().Settings.email}
                                                            </label>
                                                            <div className="form__form-group-field">
                                                                <input name="customerName"
                                                                              style={{backgroundColor: '#F0F8FF'}}
                                                                              value={this.state.email}
                                                                              type="text"
                                                                              dir={"auto"}
                                                                              onChange={(event) =>
                                                                                  this.setState({email: event.target.value})}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <ButtonToolbar className='modal__footer'>
                        <Button onClick={this.toggle}>{TextManager.getCurrentTextResource().Text.cancel}</Button>{' '}
                        <Button outline={this.props.colored} color={this.props.color}
                                onClick={this.save}>
                            לשמור</Button>
                    </ButtonToolbar>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(ModalESim))